import React from 'react';
import { Field } from 'react-final-form';

import FieldGroup from 'Shared/components/FormComponents/FieldGroup/FieldGroup';
import FormTextEditor from 'Shared/components/FormComponents/FormTextEditor';
import FormDateTimePicker from 'Shared/components/FormComponents/FormDateTimePicker';
import { required, requiredEditorText } from 'Shared/utils/formValidations';
import WpIcon from 'Wpds/components/icon/WpIcon';
import Colors from 'Wpds/colors/ColorConstants';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

import OwnerField from './OwnerField/OwnerField';

function FormFields() {
  const { tr } = useTranslation();

  return (
    <>
      <FieldGroup
        label={tr('perform.modals.create_feedback_ai.title_label')}
        labelClassName="CreateFeedbackAIModal__label"
      >
        <Field
          name="title"
          validate={requiredEditorText}
          errorLabel
          component={FormTextEditor}
          placeholder={tr('perform.modals.create_feedback_ai.title_placeholder')}
        />
      </FieldGroup>

      <div className="d-flex w-100 mt-1 pb-3">
        <FieldGroup
          label={tr('perform.modals.create_feedback_ai.due_date_label')}
          labelClassName="CreateFeedbackAIModal__label"
          className="w-50 mr-4"
        >
          <Field
            name="dueDate"
            component={FormDateTimePicker}
            inputClassName="CreateFeedbackAIModal__date-input"
            validate={required}
            placeholder={tr('perform.modals.create_feedback_ai.due_date_placeholder')}
            dateFormat="ll"
            timeFormat={false}
            icon={<WpIcon name="calendar-plus" color={Colors.gray[600]} />}
          />
        </FieldGroup>

        <FieldGroup
          label={tr('perform.modals.create_feedback_ai.owner_label')}
          labelClassName="CreateFeedbackAIModal__label"
          className="w-75"
        >
          <Field name="owner" component={OwnerField} />
        </FieldGroup>
      </div>
    </>
  );
}

export default FormFields;
